import { useMutation } from "@tanstack/react-query";

import { useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { privateAxios } from "../axiosInstances";
import { UpsertChatboxQuestionForm } from "../schemas/faq-chatbox";
import faqChatbotQueryKeys from "../query-keys/faq-chatbot.query-keys";

const createFaqQuestion = async ({
  data,
}: {
  data: UpsertChatboxQuestionForm;
}) => {
  try {
    const { data: response } = await privateAxios.post(`/faq-chatbot`, data);
    return response;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useCreateFaqChatboxQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createFaqQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: faqChatbotQueryKeys.all,
      });
    },
  });
};

const updateFaqQuestion = async ({
  id,
  data,
}: {
  id: string;
  data: UpsertChatboxQuestionForm;
}) => {
  try {
    const { data: response } = await privateAxios.patch(
      `/faq-chatbot/${id}`,
      data
    );
    return response;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useUpdateFaqChatboxQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateFaqQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: faqChatbotQueryKeys.all,
      });
    },
  });
};

const deleteFaqQuestion = async ({ id }: { id: string }) => {
  try {
    const { data: response } = await privateAxios.delete(`/faq-chatbot/${id}`);
    return response;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useDeleteFaqChatboxQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteFaqQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: faqChatbotQueryKeys.all,
      });
    },
  });
};
